import { Result } from 'antd';
import { Props } from './types';
import { FC } from 'react';

export const ILSResult: FC<Props> = (props) => {
  return <Result {...props} />;
};
